import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { InsuranceMetadatas, Lead } from 'src/app/_types/lead.types';

@Directive()
export abstract class SendLeadBase {
  @Input() lead: Lead;

  @Input() metadata: InsuranceMetadatas;

  @Output()
  sent = new EventEmitter<void>();

  abstract openModal(): void;

  abstract sendLeadToInsurer(): Observable<boolean>;

  canSendLeadToInsurer(): boolean {
    return false;
  }
}
